import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xx7ucn4sqv: FaireBrandEntity = {
  token: "b_xx7ucn4sqv",
  type: "brand",
  name: "TICTOC",
  avatarUrl:
    "https://cdn.faire.com/fastly/88e73670911867c1ddb4e8f005e7590d37654bf652d87ba05a94e1c49f713266.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/fff45a07a17894d924ffab0b9a6e99982d86882a526fa3302710f796352599c9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/88e73670911867c1ddb4e8f005e7590d37654bf652d87ba05a94e1c49f713266.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fff45a07a17894d924ffab0b9a6e99982d86882a526fa3302710f796352599c9.jpeg",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 35,
  rating: 4.8,
  reviewCount: 165,
  isTopShop: true,
  isInsider: true,
  description:
    "TIC TOC is a wholesale clothing brand based in Los Angeles, offering a curated selection of timeless and trend-conscious women’s fashion. With a focus on modern Western, cottagecore, and laid-back essentials, our collections reflect a refined take on everyday style. We release new styles regularly, designed to fit effortlessly into boutique and lifestyle retail settings. Our pieces are created with comfort, quality, and versatility in mind. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:43.972Z",
    importedBy: "entity-db-cli",
  },
};
